import { guideIdPrefixTypeMap, types } from './constants';
export function matchGuideItemNumber(guideId) {
    if (!guideId) {
        return false;
    }
    return !Number.isNaN(+guideId.substring?.(1));
}
export function isType(guideId, ...guideItemTypes) {
    if (!guideId) {
        return false;
    }
    const isNumber = matchGuideItemNumber(guideId);
    const guideItemType = guideIdPrefixTypeMap[guideId[0]];
    return isNumber && guideItemTypes.includes(guideItemType);
}
export function getType(guideId) {
    return guideId ? guideIdPrefixTypeMap[guideId[0]] : null;
}
export function getTypeLowerCase(guideId) {
    const type = getType(guideId);
    return type ? type.toLowerCase() : null;
}
export function isTopic(guideId) {
    return isType(guideId, types.topic);
}
export function isAudioClip(guideId) {
    return isType(guideId, types.audioClip);
}
export function isUser(guideId) {
    return isType(guideId, types.user);
}
export function isProgram(guideId) {
    return isType(guideId, types.program);
}
export function isStation(guideId) {
    return isType(guideId, types.station);
}
